import React, { useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import { Link } from "react-router-dom";
import { fetchBlog } from "../../Redux/WebsiteSlice";
import lower_back from "../../assets/img/reasons-for-lower-back-pain.webp";
import "./BlogList.scss";

const BlogList = () => {
  const dispatch = useDispatch();
  const blog = useSelector((state) => state.website.blog);
  const loading = useSelector((state) => state.website.loading);

  useEffect(() => {
    // Fetch all blogs (pass a large number to get all blogs)
    dispatch(fetchBlog(1000));
  }, [dispatch]);

  const getImageUrl = (url) => {
    if (!url) return null;
    if (url.startsWith('http')) return url;
    if (url.startsWith('/uploads/')) {
      const base = 'https://api-test.swifttoolskit.cloud/api';
      return base + url;
    }
    return url;
  };

  if (loading) {
    return (
      <div className="blog-list-loading">
        <div className="loading-message">Loading blogs...</div>
      </div>
    );
  }

  return (
    <div className="main main_blog">
      <div className="hero-width0">
        <div id="beforemain_wrap">
          <main id="main-areaarticle">
            <article id="main-area">
              <section
                id="comp_latest_news_1"
                className="compSection compSection_12 comp_latest_news comp_latest_news_1 textcolor__default"
                data-animate="1"
                style={{ zIndex: 1, paddingTop: "100px" }}
              >
                <div className="row row--heading to_animate">
                  <div className="standardTextContentBLock layout__center">
                    <div className="block block__first">
                      <span className="small__text">BLOG</span>
                      <h2 className="headline__text h2">
                        Latest News <span>& Articles</span>
                      </h2>
                    </div>
                    <div className="block block__last"></div>
                  </div>
                </div>
                <div className="row row--articles">
                  {blog && blog.length > 0 ? (
                    <>
                      <div className="articles__wrapper">
                        {blog.map((post) => (
                          <div key={post._id} className="article">
                            <Link
                              className="link-to-post"
                              to={`/blog/${post._id}`}
                            ></Link>
                            <div className="meta">
                              {post.category && (
                                <span className="post__cat">{post.category}</span>
                              )}
                              <h4 className="post__title">
                                {post.title}
                              </h4>
                              {post.author && (
                                <span className="post__author">by {post.author}</span>
                              )}
                            </div>
                            <div className="img_wrap">
                              <img 
                                src={post.image ? getImageUrl(post.image) : lower_back} 
                                alt={post.title}
                                onError={(e) => {
                                  e.target.src = lower_back;
                                }}
                              />
                            </div>
                            <div className="excerpt">
                              {post.excerpt || (post.content ? post.content.substring(0, 150) + '...' : '')}
                            </div>
                            <Link
                              className="site__button site__button_style--solid site__button_shape--default"
                              to={`/blog/${post._id}`}
                            >
                              <span className="text">Read more</span>
                            </Link>
                          </div>
                        ))}
                      </div>
                    </>
                  ) : (
                    <div className="no-blogs-message">
                      <p>No blog posts available at the moment.</p>
                    </div>
                  )}
                </div>
              </section>
            </article>
          </main>
        </div>
      </div>
    </div>
  );
};

export default BlogList;
